import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { RouterLink, Link } from 'components';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

class Menu extends Component {
  componentDidMount = () => {
    const { activeLink } = this;

    if (activeLink && typeof activeLink.scrollIntoViewIfNeeded === 'function') {
      this.activeLink.scrollIntoViewIfNeeded();
    }
  }

  render() {
    const {
      className,
      entries,
      activeEntry,
      onEntryClick,
      idProperty,
      labelProperty,
      counterProperty,
    } = this.props;

    return (
      <nav className={cx('component', className)}>
        {entries.map((entry, index) => (
          <div
            className={cx('entry', { active: index === activeEntry })}
            key={`menu-item-${entry[idProperty]}`}
            ref={index === activeEntry
              ? (el) => { this.activeLink = el; }
              : null}
          >
            {index === activeEntry && entry[labelProperty]}

            {index !== activeEntry && (
              (entry.path || entry.url) && !entry.newPage ? (
                <RouterLink
                  className="link--hidden-visited-color"
                  to={entry.path || entry.url}
                >
                  {entry[labelProperty]}
                </RouterLink>
              ) : (
                <Link
                  className={['hideVisitedColor', cx('label')]}
                  href={entry.newPage && (entry.path || entry.url)}
                  target={entry.newPage && '_blank'}
                  onClick={() => {
                    if (!entry.newPage) onEntryClick(entry, index);
                  }}
                >
                  {entry[labelProperty]}
                </Link>
              )
            )}
            {entry[counterProperty] ? (
              <span className={cx('count')}>
                {' '}
                {entry[counterProperty]}
              </span>
            ) : null}
          </div>
        ))}
      </nav>
    );
  }
}

Menu.defaultProps = {
  onEntryClick: () => {},
  idProperty: 'id',
  labelProperty: 'label',
  counterProperty: 'count',
  activeEntry: 0,
};

Menu.propTypes = {
  className: PropTypes.any,
  entries: PropTypes.array,
  activeEntry: PropTypes.number,
  onEntryClick: PropTypes.func,
  idProperty: PropTypes.string,
  labelProperty: PropTypes.string,
  counterProperty: PropTypes.string,
};

export default Menu;
